import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { IUser } from '../interfaces';
import { EUserRole } from '../enums';
import { catchError, map, of } from 'rxjs';

export const RoleGuard: CanActivateFn = (route, state) => {
  const _router: Router = inject(Router);
  const user: IUser = JSON.parse(localStorage.getItem('sessionUser') || '{}');

  return of(user).pipe(
    map((response: IUser) => {
      if (route.data['roles'].includes(response.role)) {
        return true;
      } else {
        if (response.role === EUserRole.ADMIN) {
          _router.navigate(['/admin']);
          return false;
        } else {
          _router.navigate(['/doctor']);
          return false;
        }
      }
    }),
    catchError(() => {
      _router.navigate(['/']);
      return of(true);
    })
  );
};
